import { pricingBasisLine } from '../lib/pricing-basis';
import { PricingReadinessAlert } from './pricing-readiness-alert';
import { QpDialogWarning } from './qp-dialog-warning';

import type { TicketContextForTradeInvoice } from './trade-invoice-payload';

export function PricingBasisLine({ ticket }: { readonly ticket: TicketContextForTradeInvoice }) {
  return (
    <p className="text-muted-foreground text-sm" data-testid="provisional-pricing-basis">
      Pricing basis: {pricingBasisLine(ticket)}
    </p>
  );
}

export interface ProvisionalGatesProps {
  readonly ticket: TicketContextForTradeInvoice;
  readonly blOrderId: string;
  readonly side: 'buy' | 'sell';
  readonly pricingReady: boolean;
  readonly missingFields: string[];
  readonly ticketId: string | null;
  readonly readinessLoaded: boolean;
}

// The pre-form context strip: pricing basis, the pricing-readiness gate, and
// the quotational-period warning.
export function ProvisionalGates({ props }: { readonly props: ProvisionalGatesProps }) {
  return (
    <>
      <PricingBasisLine ticket={props.ticket} />
      {props.readinessLoaded && !props.pricingReady && (
        <PricingReadinessAlert
          missingFields={props.missingFields}
          ticketId={props.ticketId}
          testId="provisional-pricing-blocked"
        />
      )}
      <QpDialogWarning blOrderId={props.blOrderId} side={props.side} />
    </>
  );
}
